import history from '@app/services/history';
import config from '@app/configs/config';

const ICON_FILL_COLOUR = '#4B4B4B';

const pagesMeta: Array<any> = [
  {
    id: 'contact',
    uri: '/customer/company',
    headerTitle: 'Customer profile',
    headerIcon: (
      <i
        className="ri-user-3-fill"
        style={{ fontSize: 24, color: ICON_FILL_COLOUR }}
      />
    ),
    documentTitle: 'Customer Details',
    menuTitle: 'Customer Profile',
    menuIcon: <i className="ri-user-3-fill" style={{ fontSize: 24 }} />,
    visible: true,
  },
  {
    id: 'documents',
    uri: '/customer/documents',
    headerTitle: 'Documents',
    headerIcon: (
      <i
        className="ri-wallet-fill"
        style={{ fontSize: 24, color: ICON_FILL_COLOUR }}
      />
    ),
    documentTitle: 'Company Documents',
    menuTitle: 'Documents',
    menuIcon: <i className="ri-wallet-fill" style={{ fontSize: 24 }} />,
    visible: true,
  },
  {
    id: 'banking',
    uri: '/customer/banking',
    // hasLayoutHeaderRegex: new RegExp('\\/customer\\/banking(\\/\\d+)?(\\/(manage|transactions))?$'),
    headerTitle: 'Bank Accounts',
    headerIcon: (
      <i
        className="ri-swap-fill"
        style={{
          fontSize: 24,
          color: ICON_FILL_COLOUR,
          transform: 'rotate(90deg)',
        }}
      />
    ),
    documentTitle: 'Bank Accounts',
    menuTitle: 'Bank',
    menuIcon: (
      <i
        className="ri-swap-fill"
        style={{ fontSize: 24, transform: 'rotate(90deg)' }}
      />
    ),
    visible: config.isBankModuleEnabled,
  },
  {
    id: 'credit',
    uri: '/customer/credit',
    headerTitle: 'Credit',
    headerIcon: (
      <i
        className="ri-hand-coin-fill"
        style={{ fontSize: 24, color: ICON_FILL_COLOUR }}
      />
    ),
    documentTitle: 'Credit',
    menuTitle: 'Credit',
    menuIcon: <i className="ri-hand-coin-fill" style={{ fontSize: 24 }} />,
    visible: config.isCreditModuleEnabled,
  },
];

const getPageById = (id: string) => {
  return pagesMeta.find((pageMeta) => pageMeta.id === id);
};

const resolvePageMeta = () => {
  return pagesMeta.find((pageMeta) =>
    history.location.pathname.startsWith(pageMeta.uri)
  );
};

export { pagesMeta, getPageById, resolvePageMeta };
